<template>
  <div id="top-bar" class="top-bar">
    <!-- Riga principale: logo + nav + azioni -->
    <div
      class="top-bar-header"
      :class="{ 'login-layout': $route.path === '/login' }"
    >
      <!-- Logo -->
      <div class="top-bar-logo">
        <router-link
          v-if="!$route.meta.hideDropdown"
          to="/home"
          class="logo-link"
          aria-label="Vai alla home"
        >
          <img
            id="main-logo"
            src="@/assets/4AllEvent_logo.png"
            alt="4AllEvents Logo"
          />
        </router-link>
        <img
          v-else
          id="main-logo"
          src="@/assets/4AllEvent_logo.png"
          alt="4AllEvents Logo"
        />
      </div>

      <!-- Nav desktop (nascosta su mobile via CSS) -->
      <nav
        v-if="!$route.meta.hideDropdown"
        class="top-bar-nav"
        aria-label="Navigazione principale"
      >
        <router-link
          to="/home"
          class="nav-link"
          active-class=""
          exact-active-class="router-link-exact-active"
          >Home</router-link
        >
        <router-link to="/home/operators" class="nav-link"
          >Operatori</router-link
        >
        <router-link to="/home/stock" class="nav-link">Magazzino</router-link>
        <router-link to="/home/quotes" class="nav-link">Preventivi</router-link>
        <router-link to="/home/clients" class="nav-link">Clienti</router-link>
        <router-link to="/home/account" class="nav-link">Account</router-link>
      </nav>

      <!-- Azioni: hamburger (mobile) + logout (desktop) -->
      <div class="top-bar-actions">
        <button
          v-if="!$route.meta.hideDropdown"
          class="hamburger-btn"
          @click="toggleMobileMenu"
          :aria-label="showMobileMenu ? 'Chiudi menu' : 'Apri menu'"
          :aria-expanded="showMobileMenu.toString()"
        >
          <font-awesome-icon
            :icon="['fas', showMobileMenu ? 'xmark' : 'bars']"
          />
        </button>
        <button
          class="logout-button"
          v-if="!$route.meta.hideButton"
          @click="logout"
        >
          Logout
        </button>
      </div>
    </div>

    <!-- Menu mobile (slide-down, visibile solo su mobile tramite v-if + CSS) -->
    <nav
      v-if="showMobileMenu && !$route.meta.hideDropdown"
      class="mobile-nav"
      aria-label="Menu mobile"
    >
      <router-link
        to="/home"
        class="mobile-nav-link"
        active-class=""
        exact-active-class="mobile-nav-link--active"
        @click="showMobileMenu = false"
        >Home</router-link
      >
      <router-link
        to="/home/operators"
        class="mobile-nav-link"
        active-class="mobile-nav-link--active"
        @click="showMobileMenu = false"
        >Operatori</router-link
      >
      <router-link
        to="/home/stock"
        class="mobile-nav-link"
        active-class="mobile-nav-link--active"
        @click="showMobileMenu = false"
        >Magazzino</router-link
      >
      <router-link
        to="/home/quotes"
        class="mobile-nav-link"
        active-class="mobile-nav-link--active"
        @click="showMobileMenu = false"
        >Preventivi</router-link
      >
      <router-link
        to="/home/clients"
        class="mobile-nav-link"
        active-class="mobile-nav-link--active"
        @click="showMobileMenu = false"
        >Clienti</router-link
      >
      <router-link
        to="/home/account"
        class="mobile-nav-link"
        active-class="mobile-nav-link--active"
        @click="showMobileMenu = false"
        >Account</router-link
      >
      <div class="mobile-nav-divider"></div>
      <button
        v-if="!$route.meta.hideButton"
        class="mobile-logout-btn"
        @click="logout"
      >
        Logout
      </button>
    </nav>

    <!-- Success message -->
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
      class="success-message-base"
    >
      {{ successMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: "TopBar",
  data() {
    return {
      showMobileMenu: false,
    };
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler() {
        this.showMobileMenu = false;
      },
    },
  },
  mounted() {
    document.addEventListener("click", this.closeMenu);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeMenu);
  },
  methods: {
    toggleMobileMenu(event) {
      event.stopPropagation();
      this.showMobileMenu = !this.showMobileMenu;
    },
    closeMenu(event) {
      if (!this.$el.contains(event.target)) {
        this.showMobileMenu = false;
      }
    },
    async logout() {
      try {
        const response = await this.$axios.post("/auth/logout");
        if (response.status === 200) {
          const successMessage =
            response.data.message || "Logout effettuato con successo!";
          this.$toast.success(successMessage);
          this.$store.commit("SET_OPERATOR_ROLE", null);
          localStorage.removeItem("operatorRole");
          setTimeout(() => {
            this.$router.push("/login");
          }, 2500);
        }
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || "Errore durante il logout.";
        this.$toast.error(errorMessage);
      }
    },
  },
};
</script>

<style src="@/css/App.css"></style>
